import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {LocalStorageService} from 'ngx-webstorage';
import 'rxjs/add/observable/of';

import { environment } from '../../environments/environment';

@Injectable()
export class CommonService {

  private serverUrl = environment.serverUrl;

  constructor(private http: HttpClient,
              private localSt: LocalStorageService) {}

  getConfig(): Observable<any> {
    return this.http.get(this.serverUrl + 'configurations');
  }

  getFaqList(data): Observable<any> {
    return this.http.get(this.serverUrl + 'faqs', data);
  }

  aboutUs(): Observable<any> {
    return this.http.get(this.serverUrl + 'aboutus');
  }

  terms(): Observable<any> {
    return this.http.get(this.serverUrl + 'terms');
  }

}



// WEBPACK FOOTER //
// ./src/app/services/common.service.ts